(function($) {
    var cachedElem = {};

    $.expr.pseudos.visible = function( elem ) {
        if(cachedElem[elem]) return cachedElem[elem]
        cachedElem[elem] = !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )
        return cachedElem[elem]
    };
})(jQuery)